import { PlateTypesParamType } from '@/common/queries/selections/plateType/plateType.type';
import { getPlateTypeFunction } from '@/common/queries/selections/plateType/plateTypeFunction';
import { queryOptions } from '@tanstack/react-query';

export const getPlateTypeOption = (param: PlateTypesParamType) =>
  queryOptions({
    queryKey: ['get_plate_type', param],
    queryFn: () => getPlateTypeFunction(param),
  });
